import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";
import dealServiceSteps from "./dealServiceSteps";
import GroupButtons from "../../../../../ui/button/groupButtons";
import {
  TBooleanKeysOfIFillDataWizardDealService,
  TKeyOfDataWizardDealService,
} from "..";

interface IStepDealService_3 {
  onChange: (
    data: boolean,
    key: TBooleanKeysOfIFillDataWizardDealService
  ) => void;
  data: boolean | null;
  isNextStepDisabled: boolean;
  onReset: (keys: TKeyOfDataWizardDealService[], data?: number[]) => void;
}

const StepDealService_3 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IStepDealService_3) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(dealServiceSteps.step_2);
    onReset(["isAllParticipantDealInCity"]);
  };

  const handleNextStep = () => {
    goToStep(dealServiceSteps.step_4);
  };

  const handleChange = (data: boolean) => {
    onChange(data, "isAllParticipantDealInCity");
  };

  return (
    <BaseStep
      text="Все участники сделки находятся в Красноярске?"
      nextStep={handleNextStep}
      prevStep={handlePrevStep}
      isNextStepDisabled={isNextStepDisabled}
    >
      <GroupButtons
        data={[
          {
            onClick: () => handleChange(true),
            label: "Да",
            variant: data === true ? "dark" : "lightDark",
          },
          {
            onClick: () => handleChange(false),
            label: "Нет",
            variant: data === false ? "dark" : "lightDark",
          },
        ]}
      />
    </BaseStep>
  );
};

export default StepDealService_3;
